export var EVariants = /* @__PURE__ */ ((EVariants2) => {
  EVariants2["NEUTRAL"] = "neutral";
  EVariants2["INFORMATIVE"] = "informative";
  EVariants2["WARNING"] = "warning";
  EVariants2["ERROR"] = "error";
  EVariants2["SUCCESS"] = "success";
  return EVariants2;
})(EVariants || {});
